import CryptoJS from 'crypto-js'

// 与后端 com.yawei.common.utils.Aes 保持一致：AES/ECB/PKCS7，密钥 sdyawei_software
const KEY = CryptoJS.enc.Utf8.parse('sdyawei_software')

// AES 加密，返回 Base64 字符串
export function encrypt(data) {
  const encrypted = CryptoJS.AES.encrypt(data, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// AES 解密，返回明文 UTF-8 字符串
export function decrypt(text) {
  const decrypted = CryptoJS.AES.decrypt(text, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
